module.exports = __webpack_public_path__ + "static/media/stored-documents.1473661d.png";